import React from 'react';
import '../styles/loading.scss';

const LoadingWidget = () => {
  return (
    <div className="loading-container">
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
      <p className="loading-text">Loading map data, please wait...</p>
    </div>
  );
};

export default LoadingWidget;
